import React from "react";
import { useParams } from "react-router";
import { PaperTabLayout } from "frontend/src/ui/paper-tab-layout";
import { Form } from "./music-archive";
import { useMusicArchive, useMusicArchiveDetail } from "./music-archive/model";
import { usePlaylistDetail } from "frontend/src/domain/playlists";
import { useClient } from "frontend/src/domain/client";
import { AdminLayout } from "frontend/src/pages/layouts";
import { TabsSkeleton } from "frontend/src/ui/tabs-skeleton";
import { Skeleton } from "@material-ui/lab";
import { Box, Paper, Typography } from "@material-ui/core";
import { TableSkeleton } from "frontend/src/ui/table-skeleton";
var Page = function (_a) {
    var _b, _c, _d;
    var musicArchive = _a.musicArchive;
    var _e = useMusicArchive(musicArchive), clientId = _e.clientId, actions = _e.actions;
    var playlist = usePlaylistDetail(musicArchive.playlist_id).playlist;
    var archiveClient = (musicArchive.client_id
        ? useClient(musicArchive.client_id)
        : { data: null }).data;
    var playlistClient = playlist && playlist.type === "private" ? playlist.client : null;
    var archiveClientTitle = archiveClient
        ? [archiveClient.contractNumber, (_b = archiveClient.russianLegalEntity) === null || _b === void 0 ? void 0 : _b.title].filter(Boolean).join(" / ")
        : "Все клиенты";
    var playlistClientTitle = playlist && playlist.type === "private"
        ? (_c = playlist.clientLogin) !== null && _c !== void 0 ? _c : "\u041A\u043B\u0438\u0435\u043D\u0442 #" + playlist.client.id
        : "Публичный плейлист";
    var _f = React.useState((clientId.value === null ? 'public' : 'private')), musicArchiveType = _f[0], setType = _f[1];
    var passedType = {
        value: musicArchiveType,
        onChange: function (value) {
            if (value == 'public') {
                actions.setPublic.run();
            }
            setType(value);
        }
    };
    var tabs = [
        {
            label: "Архив плейлиста",
            node: (React.createElement(React.Fragment, null,
                React.createElement(Box, { component: Paper, p: 2, mb: 2 },
                    React.createElement(Typography, { variant: "subtitle1" }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E\u0431 \u0430\u0440\u0445\u0438\u0432\u0435"),
                    React.createElement(Typography, null,
                        "ID \u0430\u0440\u0445\u0438\u0432\u0430: ",
                        musicArchive.id),
                    React.createElement(Typography, null,
                        "\u0424\u0430\u0439\u043B: ",
                        musicArchive.filename),
                    React.createElement(Typography, null,
                        "\u041F\u043B\u0435\u0439\u043B\u0438\u0441\u0442: ", (_d = playlist === null || playlist === void 0 ? void 0 : playlist.title) !== null && _d !== void 0 ? _d : "#" + musicArchive.playlist_id),
                    React.createElement(Typography, null,
                        "\u041A\u0430\u0431\u0438\u043D\u0435\u0442 \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442\u0430: ",
                        playlistClientTitle),
                    React.createElement(Typography, null,
                        "\u0414\u043E\u0441\u0442\u0443\u043F \u0430\u0440\u0445\u0438\u0432\u0430: ",
                        archiveClientTitle)),
                React.createElement(Form, { client: clientId, type: passedType, handlers: {
                        submit: {
                            do: actions.update.run,
                            pending: actions.update.pending,
                        },
                    } }))),
        },
    ];
    return React.createElement(PaperTabLayout, { tabs: tabs, keepMounted: true });
};
export var EditMusicArchivePage = function () {
    var id = useParams().id;
    var _a = useMusicArchiveDetail(Number(id)), musicArchive = _a.musicArchive, remove = _a.remove;
    React.useEffect(function () {
        return remove;
    }, []);
    return (React.createElement(AdminLayout, null, !musicArchive ? (React.createElement(TabsSkeleton, null,
        React.createElement(Skeleton, { variant: "rect", height: 200, width: "100%" }),
        React.createElement(Box, { mt: 1 },
            React.createElement(TableSkeleton, { rows: 25, columns: 6 })))) : (React.createElement(Page, { musicArchive: musicArchive }))));
};
